import { service } from "../utils/request";

// 获取优惠券设置
export function getCouponSetting(data) {
  return service({
    url: "api/config.Preferce/index",
    method: "post",
    data: data
  });
}

// 设置优惠券设置
export function setCouponSetting(data) {
  return service({
    url: "api/config.Preferce/setConfig",
    method: "post",
    data: data
  });
}